import React, {useState} from "react";

import {TableContext} from "../index";
import {debug} from "../utils";
import {useHistory} from "react-router-dom";
import ViolationsTableHeader from "./ViolationsTableHeader";
import ViolationsTable from "./ViolationsTable";
import PaginationManager from "../view/PaginationManager";
import * as ruleService from "../rules/ruleService";

function ViolationsTableSection(props) {

    const history = useHistory();

    const initTableConfig = {
        selected: []
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <TableContext.Provider value={{config: tableConfig, setConfig: changeTableConfig}}>
            <div className="container-fluid" key={history.location}>
                <div className="row">
                    <div className="col-12">
                        <div className="card oct_table-card">
                            <ViolationsTableHeader/>
                            <div className="card-body">
                                <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <ViolationsTable/>
                                            <PaginationManager getPage={ruleService.violationsList}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TableContext.Provider>
    )
}

export default ViolationsTableSection;
